import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Dashboard from '../components/Dashboard/Dashboard';
import DocumentsVerification from '../components/Dashboard/DocumentsVerification';
import RoommateGroupView from '../components/Roommates/RoommateGroupView';
import FavoriteBuildings from '../components/Dashboard/FavoriteBuildings';
import Chatbot from '../components/Dashboard/ChatBot';
import Sidebar from '../components/Dashboard/Sidebar';
import ActivityFeed from '../components/Dashboard/ActivityFeed';
import RoleToggleFeedback from '../components/common/RoleToggleFeedback';
import styles from '../styles/Dashboard/ProfileDashboardPage.module.css';


const ProfileDashboardPage = () => {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [role, setRole] = useState('Tenant');
  const [highlightedSidebarItem, setHighlightedSidebarItem] = useState(null);
  const navigate = useNavigate();

  const tenantUserId = localStorage.getItem('tenantUserId');

  const handleFeedback = () => {
    window.open('mailto:ACodding@mba2025.hbs.edu?subject=Bug Report / Feedback', '_blank');
  };
  
  const handleTabChange = (tab) => {
    if (tab === 'tenant') {
      navigate('/tenant');
    } else {
      setActiveTab(tab);
    }
  };
  
   const handleRoleChange = (newRole) => {
    setRole(newRole);
    if (newRole === 'Landlord') navigate('/landlord');
  };
  
  
  const renderContent = () => {
    switch (activeTab) {
      case 'dashboard':
        return <Dashboard 
				  setActiveTab={handleTabChange} 
				  setHighlightedSidebarItem={setHighlightedSidebarItem}
				/>
      case 'favorites':
        return <FavoriteBuildings tenantUserId={tenantUserId} />;
      case 'groups':
        return <RoommateGroupView tenantId={tenantUserId} />;
      case 'documents':
        return <DocumentsVerification tenantUserId={tenantUserId} />;
	  case 'Chat':
        return <Chatbot tenantUserId={tenantUserId}/>;
      case 'settings':
        return <div>Account Settings View (coming soon)</div>;
      default:
        return <Dashboard />;
    }
  };

  return (  
    <div className={styles.profilePage}>
		<div className={highlightedSidebarItem ? styles.overlayVisible : styles.overlayHidden}></div>
		<Sidebar
		  activeTab={activeTab}
		  setActiveTab={handleTabChange}
		  highlightedSidebarItem={highlightedSidebarItem}
		/>
      <div className={styles.mainContent}>
        {renderContent()}
      </div>
      <ActivityFeed />
      <RoleToggleFeedback 
        role={role}
        onRoleChange={handleRoleChange}
        onFeedback={handleFeedback}
      />
    </div>
  );
};

export default ProfileDashboardPage;
